module.exports = __webpack_public_path__ + "img/bigBasket-icon.0fab4f13.png";